import {ElementType} from '@app/modules/svg/dataSource/constant/ElementType';
import {Point} from '@app/modules/svg/model/Point';
import {SVGEvent} from '@app/modules/svg/dataSource/constant/SVGEvent';
import {PointType, SegmentView} from '@app/modules/svg/element/complex/cartesian/graphic/SegmentView';
import {PointedView} from '@app/modules/svg/element/shape/pointed/PointedView';
import {DrawLine} from '@app/modules/svg/service/tool/draw/element/shape/pointed/DrawLine';

export class DrawSegment extends DrawLine {
  public startPointType: PointType = PointType.OPEN;
  public endPointType: PointType = PointType.OPEN;

  protected createDrawableElement(position: Point): PointedView {
    return new SegmentView(
      this.drawTool.container,
      {overEvent: true, globalStyle: true, startPointType: this.startPointType, endPointType: this.endPointType},
      position,
      position
    );
  }

  public override start(call: boolean): void {
    super.start(call);

    if (call) {
      this.drawTool.container.__call__(SVGEvent.SEGMENT_TOOL_ON);
    }
  }
  public override stop(call: boolean): void {
    super.stop(call);

    if (call) {
      this.drawTool.container.__call__(SVGEvent.SEGMENT_TOOL_OFF);
    }
  }

  public _new(): DrawSegment {
    return new DrawSegment(this.drawTool);
  }
  public get type(): ElementType {
    return ElementType.SEGMENT;
  }
}
